module.exports = __webpack_public_path__ + "img/Saarni_2025.a31f2987.png";